import React, { useState } from 'react';
import toast from 'react-hot-toast';
import useStore from '../store';
import { useEscapeKey } from '../hooks/useEscapeKey';

export default function StreakFreezeModal({ habit, currentStreak, onClose, onFreezeComplete }) {
  const [loading, setLoading] = useState(false);
  const [freezeInfo, setFreezeInfo] = useState(null);
  const freezeHabit = useStore((s) => s.freezeHabit);
  const streak = currentStreak ?? habit.currentStreak ?? 0;
  useEscapeKey(onClose, !loading);

  async function handleFreeze() {
    setLoading(true);
    try {
      const result = await freezeHabit(habit.habitId);
      setFreezeInfo(result);
      toast.success('Streak frozen for today!');
      if (onFreezeComplete) onFreezeComplete(result);
    } catch (err) {
      if (err.code === 'FREEZE_LIMIT') {
        toast.error('No freezes remaining this month');
      } else if (err.code === 'PREMIUM_REQUIRED') {
        toast.error('Streak freeze requires Premium');
      } else {
        toast.error('Failed to freeze streak');
      }
    }
    setLoading(false);
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-white dark:bg-gray-800 rounded-2xl p-6 text-center animate-scale-in">
        <div className="text-4xl mb-3">🧊</div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Streak Freeze
        </h2>

        {freezeInfo ? (
          <>
            <p className="text-gray-500 dark:text-gray-400 mb-4">
              Your streak for <strong>{habit.name}</strong> is protected today!
            </p>
            <p className="text-sm text-gray-400 dark:text-gray-500 mb-4">
              {freezeInfo.freezesRemaining} of 3 freezes remaining this month
            </p>
            <button
              onClick={onClose}
              className="w-full py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors"
            >
              Done
            </button>
          </>
        ) : (
          <>
            <p className="text-gray-500 dark:text-gray-400 mb-4">
              Protect your <strong>{streak}-day</strong> streak for{' '}
              <strong>{habit.name}</strong> by freezing today. Your streak will be preserved
              even without a check-in.
            </p>
            <p className="text-sm text-gray-400 dark:text-gray-500 mb-4">
              3 freezes per month
            </p>
            <button
              onClick={handleFreeze}
              disabled={loading}
              className="w-full py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors mb-2 disabled:opacity-50"
            >
              {loading ? 'Freezing...' : 'Freeze Today'}
            </button>
            <button
              onClick={onClose}
              className="text-sm text-gray-500 dark:text-gray-400"
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
}
